import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ReasonsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ReasonRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const ReasonBox = styled.div`
  flex: 1;
`
